import React, { useContext } from "react";
import Onboard from "../../components/Onboard";
import { useNavigate } from "react-router-dom";
import AppContext from "../../AppContext";

const ChangePlanPage = () => {
  const { isAuth, user } = useContext(AppContext);

  const navigate = useNavigate();

  // * Don't allow unauthed users in
  if (!isAuth) {
    navigate("/");
    return;
  }

  return <Onboard currentPlan={user.plan} navigate={navigate} />;
};

ChangePlanPage.propTypes = {};

export default ChangePlanPage;
